import { createSlice } from '@reduxjs/toolkit';

const eventSlice = createSlice({
	name: 'event',
	initialState: {
		itikaafEvents: [],
	},
	reducers: {
		getItikaafEventLists: (state, { payload }) => {
			state.itikaafEvents = payload;
		},
	},
});

export const { getItikaafEventLists } = eventSlice.actions;
export const eventSelector = (state) => state.event;
export default eventSlice.reducer;
